import * as COMMON_ACTION_TYPES from '../actions/commonActionTypes';
import * as CALENDAR_ACTION_TYPES from '../../calendars/actions/calendarsActionTypes';

const CommonActionTypesMapping = {
    marquee: {
        actionType: COMMON_ACTION_TYPES.updateMarquee,
        isConversionRequired: true
    },
    footer: {
        actionType: COMMON_ACTION_TYPES.updateFooter,
        isConversionRequired: false
    },
    promo_wells: {
        actionType: COMMON_ACTION_TYPES.updatePromoWells,
        isConversionRequired: true
    },
    calendars_pricing_details: {
        actionType: COMMON_ACTION_TYPES.updatePricingDetails,
        isConversionRequired: true
    }
};

export const CalendarActionTypesMapping = {
    calendar_types_section: {
        actionType: CALENDAR_ACTION_TYPES.updateCalendarTypes,
        isConversionRequired: true
    },
    calendar_types_section_headings: {
        actionType: CALENDAR_ACTION_TYPES.updateCalendarTypesSectionHeadings,
        isConversionRequired: false
    },
    two_up_section: {
        actionType: CALENDAR_ACTION_TYPES.updateTwoUpSection,
        isConversionRequired: true
    },
    standalone_contents: {
        actionType: CALENDAR_ACTION_TYPES.updateStandaloneConents,
        isConversionRequired: true
    },
    marquee_side_panel: {
        actionType: CALENDAR_ACTION_TYPES.updateMarqueeSidePanelDetails,
        isConversionRequired: true
    },
    ...CommonActionTypesMapping
};
